import { Component, Prop, h } from '@stencil/core';
import { Arrow } from '../../icons/index';
import { isRtl } from '@ugc-utils/utils';
import state from '@ugc-store';

@Component({
  tag: 'ugc-read-more',
  shadow: false,
})
export class UgcReadMore {
  @Prop() isBetween: boolean = false;
  @Prop() partNumber: string = '';
  @Prop() href: string = '';
  @Prop() isReview: boolean = false;

  render() {
    const { isDesktop } = state;
    return (
      <a
        href={this.href}
        data-ga-event-category="ugc"
        data-ga-event-action={this.isReview ? 'view all reviews' : 'view all qna'}
        data-ga-event-label={`${this.partNumber}`}
        data-ga-event-name={this.isReview ? 'ugc_reviews' : 'ugc_qna'}
        class={`mx-8 ${this.isBetween ? 'flex-row-between-center' : 'flex-row-start-center'} pointer`}
      >
        <span class={`${isDesktop ? 'fs-16' : 'fs-14'} color-blue-dark`}>
          <slot />
        </span>
        <div class="flex-row-start-center" style={{ transform: isRtl() ? 'rotate(-270deg)' : 'rotate(-90deg)' }}>
          <Arrow width="24" height="24" fill="#126cc5" />
        </div>
      </a>
    );
  }
}
